import { render, staticRenderFns } from "./indexCCZX.vue?vue&type=template&id=22b1ab55&"
import script from "./indexCCZX.vue?vue&type=script&lang=js&"
export * from "./indexCCZX.vue?vue&type=script&lang=js&"
import style0 from "./indexCCZX.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports